var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.items,"box":"","value":_vm.value,"item-text":"label","return-object":"","label":_vm.label[_vm.$i18n.locale]},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }